<template>
    <div>
        <b-modal
            :visible="mostrarModal"
            @hide="fechar"
            size="xl"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Pagamento - Nota Fiscal -
                <b-badge
                    :variant="operacao === 'VISUALIZAR' ? 'info' : 'warning'"
                    >{{
                        operacao === 'VISUALIZAR' ? 'DETALHES' : operacao
                    }}</b-badge
                >
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-tabs>
                <!-- Aba Informações Gerais -->
                <b-tab title="Informações Gerais" active>
                    <b-row class="mt-3">
                        <b-col sm="6">
                            <b-form-group label="Tipo">
                                <b-form-select
                                    v-model="tipo"
                                    :options="tiposNotaFiscal"
                                    value-field="value"
                                    text-field="text"
                                    :disabled="DesabilitarEdicao"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required">Número da Nota</label>
                                <b-form-input
                                    v-model="numeroNota"
                                    :state="$v.numeroNota.$error ? false : null"
                                    :disabled="DesabilitarEdicao"
                                ></b-form-input>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required"
                                    >Data de Emissão da NF</label
                                >
                                <date-picker
                                    v-model="dataEmissao"
                                    :config="$datePickerOptions2"
                                    :disabled="DesabilitarEdicao"
                                >
                                </date-picker>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required">Mês de Competência</label>
                                <b-form-input
                                    v-model="mesCompetencia"
                                    placeholder="MM/AAAA"
                                    v-mask="'##/####'"
                                    :state="
                                        $v.mesCompetencia.$error ? false : null
                                    "
                                    :disabled="DesabilitarEdicao"
                                ></b-form-input>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required">Valor da NF</label>
                                <money
                                    v-model="valorNota"
                                    v-bind="money"
                                    :state="$v.valorNota.$error ? false : null"
                                    :disabled="DesabilitarEdicao"
                                    class="form-control"
                                ></money>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Local de Prestação do Serviço">
                                <b-form-select
                                    v-model="localPrestacao"
                                    :options="municipiosSelect"
                                    value-field="codigo"
                                    text-field="nome"
                                    :disabled="DesabilitarEdicao"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required"
                                    >Serviço prestado por sócio/proprietário</label
                                >
                                <b-form-radio-group
                                    v-model="servicoPorSocio"
                                    :options="servicoPorSocioOptions"
                                    :state="
                                        $v.servicoPorSocio.$error ? false : null
                                    "
                                    :disabled="DesabilitarEdicao"
                                ></b-form-radio-group>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Anexo da Nota Fiscal">
                                <b-form-file
                                    v-model="arquivo"
                                    browse-text="Selecionar"
                                    placeholder="Escolha um arquivo..."
                                    :disabled="DesabilitarEdicao"
                                ></b-form-file>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-tab>

                <!-- Aba Prestador -->
                <b-tab title="Prestador">
                    <b-row class="mt-3">
                        <b-col sm="12">
                            <b-alert show variant="info">
                                <i class="fa fa-info-circle"></i>
                                Os dados do prestador são preenchidos
                                automaticamente com base nas informações
                                cadastrais do fornecedor. Apenas o campo
                                "Optante Simples Nacional" deve ser selecionado
                                manualmente.
                            </b-alert>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="CNPJ/CPF">
                                <b-form-input
                                    v-model="prestadorCnpjCpf"
                                    v-mask="prestadorCnpjCpfMask"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Inscrição Municipal">
                                <b-form-input
                                    v-model="prestadorInscricaoMunicipal"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required">Razão Social</label>
                                <b-form-input
                                    v-model="prestadorRazaoSocial"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Nome Fantasia">
                                <b-form-input
                                    v-model="prestadorNomeFantasia"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required"
                                    >Optante Simples Nacional</label
                                >
                                <b-form-radio-group
                                    v-model="prestadorOptanteSimples"
                                    :options="optanteSimplesOptions"
                                    :state="
                                        $v.prestadorOptanteSimples.$error
                                            ? false
                                            : null
                                    "
                                    :disabled="DesabilitarEdicao"
                                ></b-form-radio-group>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Telefone">
                                <b-form-input
                                    v-model="prestadorTelefone"
                                    v-mask="'(##) #####-####'"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Email">
                                <b-form-input
                                    v-model="prestadorEmail"
                                    type="email"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <!-- Campo vazio para manter layout -->
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group label="Endereço">
                                <b-form-textarea
                                    v-model="prestadorEndereco"
                                    rows="2"
                                    :disabled="true"
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-tab>

                <!-- Aba Tomador -->
                <b-tab title="Tomador">
                    <b-row class="mt-3">
                        <b-col sm="6">
                            <b-form-group label="CNPJ/CPF">
                                <b-form-input
                                    v-model="tomadorCnpjCpf"
                                    v-mask="tomadorCnpjCpfMask"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Razão Social">
                                <b-form-input
                                    v-model="tomadorRazaoSocial"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="E-mail">
                                <b-form-input
                                    v-model="tomadorEmail"
                                    type="email"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Telefone">
                                <b-form-input
                                    v-model="tomadorTelefone"
                                    v-mask="'(##) #####-####'"
                                    :disabled="true"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group label="Endereço">
                                <b-form-textarea
                                    v-model="tomadorEndereco"
                                    rows="2"
                                    :disabled="true"
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-tab>

                <!-- Aba Valores e Alíquotas -->
                <b-tab title="Valores e Alíquotas">
                    <b-row class="mt-3">
                        <b-col sm="12">
                            <h5>Valores</h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label class="required">Valor da NF</label>
                                <money
                                    :value="valorNota"
                                    v-bind="money"
                                    disabled
                                    class="form-control"
                                ></money>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Valor da Dedução">
                                <money
                                    v-model="valorDeducao"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicao"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Dedução do ISS">
                                <money
                                    v-model="deducaoIss"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Dedução do INSS">
                                <money
                                    v-model="deducaoInss"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-alert variant="info" show class="mb-3">
                                <small>
                                    <strong>Base de Cálculo:</strong> R$
                                    {{
                                        valorBaseCalculado.toLocaleString(
                                            'pt-BR',
                                            { minimumFractionDigits: 2 }
                                        )
                                    }}
                                    (Valor do Serviço - Valor da Dedução)
                                </small>
                                <br v-if="deducaoIss > 0 || deducaoInss > 0" />
                                <small v-if="deducaoIss > 0">
                                    <strong>Base do ISS:</strong> R$
                                    {{
                                        valorBaseCalculadoIss.toLocaleString(
                                            'pt-BR',
                                            { minimumFractionDigits: 2 }
                                        )
                                    }}
                                    (Base de Cálculo - Dedução do ISS)
                                </small>
                                <span v-if="deducaoIss > 0 && deducaoInss > 0">
                                    &nbsp;|&nbsp;
                                </span>
                                <small v-if="deducaoInss > 0">
                                    <strong>Base do INSS:</strong> R$
                                    {{
                                        valorBaseCalculadoInss.toLocaleString(
                                            'pt-BR',
                                            { minimumFractionDigits: 2 }
                                        )
                                    }}
                                    (Base de Cálculo - Dedução do INSS)
                                </small>
                            </b-alert>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Valor ISS">
                                <money
                                    v-model="valorIss"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="issEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Valor PIS">
                                <money
                                    v-model="valorPis"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="pisEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Valor COFINS">
                                <money
                                    v-model="valorCofins"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="cofinsEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Valor INSS">
                                <money
                                    v-model="valorInss"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="inssEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Valor IR">
                                <money
                                    v-model="valorIr"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="irEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Valor CSLL">
                                <money
                                    v-model="valorCsll"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="csllEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Valor IBS">
                                <money
                                    v-model="valorIbs"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="ibsEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Valor CBS">
                                <money
                                    v-model="valorCbs"
                                    v-bind="money"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="cbsEditadoPor = 'valor'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mt-4">
                        <b-col sm="12">
                            <h5>Alíquotas</h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Alíquota ISS">
                                <money
                                    v-model="aliquotaIss"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="issEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Alíquota PIS">
                                <money
                                    v-model="aliquotaPis"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="pisEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Alíquota COFINS">
                                <money
                                    v-model="aliquotaCofins"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="cofinsEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Alíquota INSS">
                                <money
                                    v-model="aliquotaInss"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="inssEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Alíquota IR">
                                <money
                                    v-model="aliquotaIr"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="irEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Alíquota CSLL">
                                <money
                                    v-model="aliquotaCsll"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="csllEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Alíquota IBS">
                                <money
                                    v-model="aliquotaIbs"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="ibsEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Alíquota CBS">
                                <money
                                    v-model="aliquotaCbs"
                                    v-bind="perc"
                                    class="form-control"
                                    :disabled="DesabilitarEdicaoImpostos"
                                    @focus.native="cbsEditadoPor = 'aliquota'"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-tab>

                <!-- Aba Serviços -->
                <b-tab title="Serviços">
                    <b-row class="mt-3">
                        <b-col sm="6">
                            <b-form-group label="Código da Atividades">
                                <b-form-input
                                    v-model="codigoAtividade"
                                    :disabled="DesabilitarEdicao"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Descrição da Atividade">
                                <b-form-input
                                    v-model="descricaoAtividade"
                                    :disabled="DesabilitarEdicao"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="COS Serviço">
                                <b-form-input
                                    v-model="cosServico"
                                    :disabled="DesabilitarEdicao"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Descrição do Serviço">
                                <b-form-input
                                    v-model="descricaoServico"
                                    :disabled="DesabilitarEdicao"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label class="required">Descrição da Nota</label>
                                <b-form-textarea
                                    v-model="descricaoNota"
                                    rows="3"
                                    :state="
                                        $v.descricaoNota.$error ? false : null
                                    "
                                    :disabled="DesabilitarEdicao"
                                ></b-form-textarea>
                                <b-form-invalid-feedback>
                                    Campo obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>

            <div slot="modal-footer" class="w-100 d-flex justify-content-end">
                <b-button variant="secondary" @click="fechar()" class="mr-2">
                    <span>
                        <i class="fa fa-close"></i>
                        {{
                            operacao === 'VISUALIZAR' &&
                            (perfilUsuario === 'FORNECEDOR' ||
                                perfilUsuario === 'GESTOR' ||
                                perfilUsuario === 'GERENTE')
                                ? 'Fechar'
                                : 'Cancelar'
                        }}
                    </span>
                </b-button>
                <b-button
                    variant="primary"
                    @click="salvar()"
                    :disabled="
                        pagamentoConcluido ||
                        (operacao === 'VISUALIZAR' &&
                        (perfilUsuario === 'FORNECEDOR' ||
                            perfilUsuario === 'GESTOR' ||
                            perfilUsuario === 'GERENTE')
                            ? true
                            : !isFormValid)
                    "
                    v-if="
                        !(
                            operacao === 'VISUALIZAR' &&
                            (perfilUsuario === 'GESTOR' ||
                                perfilUsuario === 'GERENTE')
                        )
                    "
                >
                    <span> <i class="fa fa-save"></i> Salvar </span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

// Alíquotas da reforma tributária pré-carregadas na inserção (editáveis pelo fornecedor)
const aliquotaIbsPadrao = 0.1
const aliquotaCbsPadrao = 0.9

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: false
        },
        operacao: {
            type: String,
            default: 'INSERIR'
        },
        pagamentoId: {
            type: [Number, String],
            default: null
        },
        pagamentosServicos: {
            type: Object,
            required: true
        },
        erros: {
            type: Array,
            default: () => []
        },
        notaFiscal: {
            type: Object,
            default: null
        },
        somenteLeitura: {
            type: Boolean,
            default: false
        },
        perfilUsuario: {
            type: String,
            default: 'FORNECEDOR'
        },
        pagamentoConcluido: {
            type: Boolean,
            default: false
        },
        valorTotal: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            tipo: null,
            numeroNota: '',
            dataEmissao: '',
            mesCompetencia: '',
            valorNota: 0,
            localPrestacao: null,
            servicoPorSocio: null,
            arquivo: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },

            prestadorCnpjCpf: '',
            prestadorInscricaoMunicipal: '',
            prestadorRazaoSocial: '',
            prestadorNomeFantasia: '',
            prestadorEmail: '',
            prestadorOptanteSimples: null,
            prestadorTelefone: '',
            prestadorEndereco: '',

            tomadorCnpjCpf: '',
            tomadorRazaoSocial: '',
            tomadorEmail: '',
            tomadorTelefone: '',
            tomadorEndereco: '',

            valorServico: 0,
            valorDeducao: 0,
            deducaoIss: 0,
            deducaoInss: 0,
            valorIss: 0,
            valorPis: 0,
            valorCofins: 0,
            valorInss: 0,
            valorIr: 0,
            valorCsll: 0,
            valorIbs: 0,
            valorCbs: 0,

            aliquotaIss: 0,
            aliquotaPis: 0,
            aliquotaCofins: 0,
            aliquotaInss: 0,
            aliquotaIr: 0,
            aliquotaCsll: 0,
            aliquotaIbs: aliquotaIbsPadrao,
            aliquotaCbs: aliquotaCbsPadrao,

            codigoAtividade: '',
            descricaoAtividade: '',
            cosServico: '',
            descricaoServico: '',
            descricaoNota: '',

            tiposNotaFiscal: [
                {
                    value: 'NFE',
                    text: 'NF-e (Nota Fiscal Eletrônica de Produtos/Mercadoria)'
                },
                {
                    value: 'CTE',
                    text: 'CT-e (Conhecimento de Transporte Eletrônico)'
                },
                {
                    value: 'NFSE',
                    text: 'NFS-e (Nota Fiscal de Serviço Eletrônica)'
                },
                {
                    value: 'NFCE',
                    text: 'NFC-e (Nota Fiscal ao Consumidor Eletrônica)'
                },
                { value: 'CFE', text: 'CF-e (Cupom Fiscal Eletrônico)' },
                { value: 'NFAE', text: 'NFA-e (Nota Fiscal Avulsa)' },
                { value: 'RECIBO', text: 'Recibo' },
                {
                    value: 'MDFE',
                    text: 'MDF-e (Manifesto Eletrônico de Documentos Fiscais)'
                },
                { value: 'RPA', text: 'RPA (Recibo de Pagamento a Autônomos)' },
                { value: 'NFS', text: 'NFS (Nota Fiscal de Serviço)' },
                { value: 'CUPOM_FISCAL', text: 'Cupom Fiscal' },
                { value: 'FATURA', text: 'Fatura' },
                {
                    value: 'NFSCE',
                    text: 'NFSC-e (Nota Fiscal de Serviço de Comunicação Eletrônica)'
                },
                { value: 'OUTROS', text: 'Outros' }
            ],
            municipiosSelect: [],
            issEditadoPor: 'aliquota',
            pisEditadoPor: 'aliquota',
            cofinsEditadoPor: 'aliquota',
            inssEditadoPor: 'aliquota',
            irEditadoPor: 'aliquota',
            csllEditadoPor: 'aliquota',
            ibsEditadoPor: 'aliquota',
            cbsEditadoPor: 'aliquota',

            perc: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: ' %',
                precision: 2,
                masked: false
            }
        }
    },

    watch: {
        mostrarModal(newVal) {
            if (newVal) {
                if (this.operacao === 'INSERIR') {
                    this.carregarDadosIniciais()
                    this.obterMunicipios()
                } else if (this.operacao === 'VISUALIZAR' && this.notaFiscal) {
                    this.preencherComDadosNotaFiscal()
                    this.obterMunicipios()
                }
            }
        },

        valorNota() {
            this.$nextTick(() => {
                this.valorServico = this.valorNota
                this.calcularValoresImpostos()
            })
        },

        valorServico() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        valorDeducao() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        valorIss() {
            this.$nextTick(() => {
                this.calcularAliquotaIss()
            })
        },

        valorPis() {
            this.$nextTick(() => {
                this.calcularAliquotaPis()
            })
        },

        valorCofins() {
            this.$nextTick(() => {
                this.calcularAliquotaCofins()
            })
        },

        valorInss() {
            this.$nextTick(() => {
                this.calcularAliquotaInss()
            })
        },

        valorIr() {
            this.$nextTick(() => {
                this.calcularAliquotaIr()
            })
        },

        valorCsll() {
            this.$nextTick(() => {
                this.calcularAliquotaCsll()
            })
        },

        valorIbs() {
            this.$nextTick(() => {
                this.calcularAliquotaIbs()
            })
        },

        valorCbs() {
            this.$nextTick(() => {
                this.calcularAliquotaCbs()
            })
        },

        deducaoIss() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        deducaoInss() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaIss() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaPis() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaCofins() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaInss() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaIr() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaCsll() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaIbs() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        aliquotaCbs() {
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        }
    },

    computed: {
        prestadorCnpjCpfMask() {
            if (this.prestadorCnpjCpf && this.prestadorCnpjCpf.length > 11) {
                return '##.###.###/####-##'
            }
            return '###.###.###-##'
        },

        tomadorCnpjCpfMask() {
            if (this.tomadorCnpjCpf && this.tomadorCnpjCpf.length > 11) {
                return '##.###.###/####-##'
            }
            return '###.###.###-##'
        },

        optanteSimplesOptions() {
            return [
                { value: true, text: 'Sim' },
                { value: false, text: 'Não' }
            ]
        },

        servicoPorSocioOptions() {
            return [
                { value: true, text: 'Sim' },
                { value: false, text: 'Não' }
            ]
        },

        DesabilitarEdicao() {
            if (this.pagamentoConcluido) {
                return true
            }

            return (
                this.operacao == 'VISUALIZAR' &&
                (this.perfilUsuario == 'FORNECEDOR' ||
                    this.perfilUsuario == 'FINANCEIRO' ||
                    this.perfilUsuario === 'GESTOR' ||
                    this.perfilUsuario === 'GERENTE')
            )
        },

        DesabilitarEdicaoImpostos() {
            if (this.pagamentoConcluido) {
                return true
            }

            return (
                this.operacao === 'VISUALIZAR' &&
                (this.perfilUsuario === 'FORNECEDOR' ||
                    this.perfilUsuario === 'GESTOR' ||
                    this.perfilUsuario === 'GERENTE')
            )
        },

        isFormValid() {
            if (this.pagamentoConcluido) {
                return false
            }

            if (
                this.operacao === 'VISUALIZAR' &&
                (this.perfilUsuario === 'FORNECEDOR' ||
                    this.perfilUsuario === 'GESTOR' ||
                    this.perfilUsuario === 'GERENTE')
            ) {
                return false
            }

            const camposBasicos = !!(
                this.numeroNota &&
                this.dataEmissao &&
                this.mesCompetencia &&
                this.valorNota &&
                this.valorServico &&
                this.prestadorRazaoSocial &&
                this.prestadorOptanteSimples !== null &&
                this.servicoPorSocio !== null &&
                this.descricaoNota
            )

            return camposBasicos
        },

        valorBaseCalculado() {
            return Math.max(0, this.valorServico - this.valorDeducao)
        },

        // ISS e INSS têm dedução própria (informada só nesta tela, não persistida)
        valorBaseCalculadoIss() {
            return Math.max(0, this.valorBaseCalculado - this.deducaoIss)
        },

        valorBaseCalculadoInss() {
            return Math.max(0, this.valorBaseCalculado - this.deducaoInss)
        }
    },

    methods: {
        preencherForm() {
            if (this.operacao === 'INSERIR') {
                this.limparForm()
                this.valorNota = this.valorTotal
            } else if (this.operacao === 'VISUALIZAR' && this.notaFiscal) {
                this.preencherComDadosNotaFiscal()
            }
        },

        preencherComDadosNotaFiscal() {
            const nf = this.notaFiscal

            this.issEditadoPor = 'aliquota'
            this.pisEditadoPor = 'aliquota'
            this.cofinsEditadoPor = 'aliquota'
            this.inssEditadoPor = 'aliquota'
            this.irEditadoPor = 'aliquota'
            this.csllEditadoPor = 'aliquota'
            this.ibsEditadoPor = 'aliquota'
            this.cbsEditadoPor = 'aliquota'
            this.tipo = nf.tipo
            this.numeroNota = nf.numeroNota
            // Converter data ISO para formato brasileiro para o date-picker
            if (nf.dataEmissao) {
                const dataISO = nf.dataEmissao.split('T')[0] // Remove timestamp se houver
                const parts = dataISO.split('-')
                if (parts.length === 3) {
                    this.dataEmissao = `${parts[2]}/${parts[1]}/${parts[0]}` // YYYY-MM-DD -> DD/MM/YYYY
                } else {
                    this.dataEmissao = dataISO
                }
            } else {
                this.dataEmissao = ''
            }
            this.mesCompetencia = nf.mesCompetencia
            this.valorNota = nf.valorNota
            this.localPrestacao = nf.localPrestacao
            this.servicoPorSocio = nf.servicoPorSocio

            this.prestadorCnpjCpf = nf.prestadorCnpjCpf
            this.prestadorInscricaoMunicipal = nf.prestadorInscricaoMunicipal
            this.prestadorRazaoSocial = nf.prestadorRazaoSocial
            this.prestadorNomeFantasia = nf.prestadorNomeFantasia
            this.prestadorOptanteSimples = nf.prestadorOptanteSimples
            this.prestadorTelefone = nf.prestadorTelefone
            this.prestadorEndereco = nf.prestadorEndereco
            this.prestadorEmail = nf.prestadorEmail

            this.tomadorCnpjCpf = nf.tomadorCnpjCpf
            this.tomadorRazaoSocial = nf.tomadorRazaoSocial
            this.tomadorEmail = nf.tomadorEmail
            this.tomadorTelefone = nf.tomadorTelefone
            this.tomadorEndereco = nf.tomadorEndereco

            this.valorServico = nf.valorServico || nf.valorNota
            this.valorDeducao = nf.valorDeducao
            this.valorIss = nf.valorIss
            this.valorPis = nf.valorPis
            this.valorCofins = nf.valorCofins
            this.valorInss = nf.valorInss
            this.valorIr = nf.valorIr
            this.valorCsll = nf.valorCsll
            this.valorIbs = nf.valorIbs || 0
            this.valorCbs = nf.valorCbs || 0

            // Notas anteriores à reforma tributária não têm IBS/CBS nem deduções gravadas
            this.deducaoIss = nf.deducaoIss || 0
            this.deducaoInss = nf.deducaoInss || 0

            this.aliquotaIss = nf.aliquotaIss
            this.aliquotaPis = nf.aliquotaPis
            this.aliquotaCofins = nf.aliquotaCofins
            this.aliquotaInss = nf.aliquotaInss
            this.aliquotaIr = nf.aliquotaIr
            this.aliquotaCsll = nf.aliquotaCsll
            this.aliquotaIbs = nf.aliquotaIbs || 0
            this.aliquotaCbs = nf.aliquotaCbs || 0

            this.codigoAtividade = nf.codigoAtividade
            this.descricaoAtividade = nf.descricaoAtividade
            this.cosServico = nf.cosServico
            this.descricaoServico = nf.descricaoServico
            this.descricaoNota = nf.descricaoNota
        },

        limparForm() {
            this.tipo = null
            this.numeroNota = ''
            this.dataEmissao = ''
            this.mesCompetencia = ''
            this.valorNota = 0
            this.localPrestacao = null
            this.servicoPorSocio = null
            this.arquivo = null

            this.prestadorCnpjCpf = ''
            this.prestadorInscricaoMunicipal = ''
            this.prestadorRazaoSocial = ''
            this.prestadorNomeFantasia = ''
            this.prestadorOptanteSimples = null
            this.prestadorTelefone = ''
            this.prestadorEndereco = ''
            this.prestadorEmail = ''

            this.tomadorCnpjCpf = ''
            this.tomadorRazaoSocial = ''
            this.tomadorEmail = ''
            this.tomadorTelefone = ''
            this.tomadorEndereco = ''

            this.valorServico = 0
            this.valorDeducao = 0
            this.deducaoIss = 0
            this.deducaoInss = 0
            this.valorIss = 0
            this.valorPis = 0
            this.valorCofins = 0
            this.valorInss = 0
            this.valorIr = 0
            this.valorCsll = 0
            this.valorIbs = 0
            this.valorCbs = 0

            this.aliquotaIss = 0
            this.aliquotaPis = 0
            this.aliquotaCofins = 0
            this.aliquotaInss = 0
            this.aliquotaIr = 0
            this.aliquotaCsll = 0
            this.aliquotaIbs = aliquotaIbsPadrao
            this.aliquotaCbs = aliquotaCbsPadrao
            this.issEditadoPor = 'aliquota'
            this.pisEditadoPor = 'aliquota'
            this.cofinsEditadoPor = 'aliquota'
            this.inssEditadoPor = 'aliquota'
            this.irEditadoPor = 'aliquota'
            this.csllEditadoPor = 'aliquota'
            this.ibsEditadoPor = 'aliquota'
            this.cbsEditadoPor = 'aliquota'

            this.codigoAtividade = ''
            this.descricaoAtividade = ''
            this.cosServico = ''
            this.descricaoServico = ''
            this.descricaoNota = ''

            this.municipiosSelect = []

            if (this.$v) {
                this.$v.$reset()
            }
        },

        async carregarDadosIniciais() {
            try {
                await this.buscarDadosFornecedor()
                await this.buscarDadosSebrae()
            } catch (error) {
                this.$toast.error(
                    'Erro ao carregar dados iniciais',
                    this.$toastConfig.error
                )
            }
        },

        async buscarDadosFornecedor() {
            try {
                const response = await axiosJwt.get(
                    `${api}/administracao/fornecedor/dadoscadastrais`
                )
                const fornecedor = response.data.data

                this.prestadorCnpjCpf = fornecedor.cpfCnpj
                this.prestadorInscricaoMunicipal = fornecedor.codCfo || ''
                this.prestadorRazaoSocial = fornecedor.nome
                this.prestadorNomeFantasia = fornecedor.nomeFantasia
                this.prestadorOptanteSimples = null
                this.prestadorTelefone = fornecedor.telefone || ''
                this.prestadorEmail = fornecedor.email

                const enderecoParts = [
                    fornecedor.logradouro,
                    fornecedor.numero,
                    fornecedor.complemento,
                    fornecedor.bairro,
                    fornecedor.cidade,
                    fornecedor.uf,
                    fornecedor.cep
                ]
                    .filter((part) => part && part.trim() !== '')
                    .join(', ')

                this.prestadorEndereco = enderecoParts
            } catch (error) {
                this.$toast.error(
                    'Erro ao carregar dados do fornecedor',
                    this.$toastConfig.error
                )
            }
        },

        async buscarDadosSebrae() {
            try {
                this.tomadorCnpjCpf = '09.366.890/0001-90'
                this.tomadorRazaoSocial =
                    'SEBRAE - Serviço Brasileiro de Apoio às Micro e Pequenas Empresas'
                this.tomadorEmail = 'atendimento@pe.sebrae.com.br'
                this.tomadorTelefone = '(81) 3348-3000'
                this.tomadorEndereco =
                    'Rua Tabaiares, 360, Ilha do Retiro, Recife, PE, 52031-030'
            } catch (error) {
                console.error('Erro ao definir dados do SEBRAE:', error)
            }
        },

        clamp(valor, min, max) {
            return Math.min(Math.max(valor, min), max)
        },

        arredondar(valor) {
            return Number.parseFloat(Number(valor || 0).toFixed(2))
        },

        atribuirSeMudou(campo, valor) {
            if (this[campo] !== valor) {
                this[campo] = valor
            }
        },

        calcularAliquotaImposto(campoValor, campoAliquota, base) {
            if (base === undefined) {
                base = this.valorBaseCalculado
            }
            if (!base) {
                return
            }
            const valor = this.arredondar(
                this.clamp(this[campoValor], 0, this.valorNota)
            )
            const aliquota = this.arredondar(
                this.clamp((valor / base) * 100, 0, 100)
            )

            this.atribuirSeMudou(campoValor, valor)
            this.atribuirSeMudou(campoAliquota, aliquota)
        },

        calcularAliquotaIss() {
            if (this.issEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto(
                'valorIss',
                'aliquotaIss',
                this.valorBaseCalculadoIss
            )
        },

        calcularAliquotaPis() {
            if (this.pisEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto('valorPis', 'aliquotaPis')
        },

        calcularAliquotaCofins() {
            if (this.cofinsEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto('valorCofins', 'aliquotaCofins')
        },

        calcularAliquotaInss() {
            if (this.inssEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto(
                'valorInss',
                'aliquotaInss',
                this.valorBaseCalculadoInss
            )
        },

        calcularAliquotaIr() {
            if (this.irEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto('valorIr', 'aliquotaIr')
        },

        calcularAliquotaCsll() {
            if (this.csllEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto('valorCsll', 'aliquotaCsll')
        },

        calcularAliquotaIbs() {
            if (this.ibsEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto('valorIbs', 'aliquotaIbs')
        },

        calcularAliquotaCbs() {
            if (this.cbsEditadoPor !== 'valor') {
                return
            }
            this.calcularAliquotaImposto('valorCbs', 'aliquotaCbs')
        },

        calcularValorImposto(campoAliquota, campoValor, base, valorNota) {
            const aliquota = this.arredondar(this.clamp(this[campoAliquota], 0, 100))
            const valor = this.arredondar(
                this.clamp(base * (aliquota / 100), 0, valorNota)
            )

            this.atribuirSeMudou(campoAliquota, aliquota)
            this.atribuirSeMudou(campoValor, valor)
        },

        calcularValoresImpostos() {
            const base = this.valorBaseCalculado
            const valorNota = this.valorNota

            if (this.issEditadoPor !== 'valor') {
                this.calcularValorImposto(
                    'aliquotaIss',
                    'valorIss',
                    this.valorBaseCalculadoIss,
                    valorNota
                )
            }
            if (this.pisEditadoPor !== 'valor') {
                this.calcularValorImposto('aliquotaPis', 'valorPis', base, valorNota)
            }
            if (this.cofinsEditadoPor !== 'valor') {
                this.calcularValorImposto(
                    'aliquotaCofins',
                    'valorCofins',
                    base,
                    valorNota
                )
            }
            if (this.inssEditadoPor !== 'valor') {
                this.calcularValorImposto(
                    'aliquotaInss',
                    'valorInss',
                    this.valorBaseCalculadoInss,
                    valorNota
                )
            }
            if (this.irEditadoPor !== 'valor') {
                this.calcularValorImposto('aliquotaIr', 'valorIr', base, valorNota)
            }
            if (this.csllEditadoPor !== 'valor') {
                this.calcularValorImposto('aliquotaCsll', 'valorCsll', base, valorNota)
            }
            if (this.ibsEditadoPor !== 'valor') {
                this.calcularValorImposto('aliquotaIbs', 'valorIbs', base, valorNota)
            }
            if (this.cbsEditadoPor !== 'valor') {
                this.calcularValorImposto('aliquotaCbs', 'valorCbs', base, valorNota)
            }
        },

        async obterMunicipios() {
            try {
                this.$store.dispatch('addRequest')
                const response = await this.pagamentosServicos.obterMunicipios()
                if (
                    response &&
                    response.success &&
                    Array.isArray(response.data)
                ) {
                    this.municipiosSelect = response.data
                } else {
                    this.municipiosSelect = []
                }
                this.$store.dispatch('removeRequest')
            } catch (error) {
                this.municipiosSelect = []
                this.$store.dispatch('removeRequest')
                console.error('Erro ao obter municípios:', error)
            }
        },

        // Converte valores monetários para números (remove formatação)

        // Converte strings de porcentagem para números

        salvar() {
            if (this.$v) {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    this.$toast.error(
                        'Preencha os campos obrigatórios!',
                        'ERROR',
                        this.$toastConfig.error
                    )
                    return
                }
            }

            const notaFiscal = {
                pagamentoId: this.pagamentoId,
                tipo: this.tipo,
                numeroNota: this.numeroNota,
                dataEmissao: this.dataEmissao,
                mesCompetencia: this.mesCompetencia,
                valorNota: this.valorNota,
                localPrestacao: this.localPrestacao,
                servicoPorSocio: this.servicoPorSocio,

                prestadorCnpjCpf: this.prestadorCnpjCpf,
                prestadorInscricaoMunicipal: this.prestadorInscricaoMunicipal,
                prestadorRazaoSocial: this.prestadorRazaoSocial,
                prestadorNomeFantasia: this.prestadorNomeFantasia,
                prestadorOptanteSimples: this.prestadorOptanteSimples,
                prestadorTelefone: this.prestadorTelefone,
                prestadorEmail: this.prestadorEmail,
                prestadorEndereco: this.prestadorEndereco,

                tomadorCnpjCpf: this.tomadorCnpjCpf,
                tomadorRazaoSocial: this.tomadorRazaoSocial,
                tomadorEmail: this.tomadorEmail,
                tomadorTelefone: this.tomadorTelefone,
                tomadorEndereco: this.tomadorEndereco,

                valorServico: this.valorServico,
                valorDeducao: this.valorDeducao,
                deducaoIss: this.deducaoIss,
                deducaoInss: this.deducaoInss,
                valorIss: this.valorIss,
                valorPis: this.valorPis,
                valorCofins: this.valorCofins,
                valorInss: this.valorInss,
                valorIr: this.valorIr,
                valorCsll: this.valorCsll,
                valorIbs: this.valorIbs,
                valorCbs: this.valorCbs,

                aliquotaIss: this.aliquotaIss,
                aliquotaPis: this.aliquotaPis,
                aliquotaCofins: this.aliquotaCofins,
                aliquotaInss: this.aliquotaInss,
                aliquotaIr: this.aliquotaIr,
                aliquotaCsll: this.aliquotaCsll,
                aliquotaIbs: this.aliquotaIbs,
                aliquotaCbs: this.aliquotaCbs,

                codigoAtividade: this.codigoAtividade,
                descricaoAtividade: this.descricaoAtividade,
                cosServico: this.cosServico,
                descricaoServico: this.descricaoServico,
                descricaoNota: this.descricaoNota
            }

            // Só incluir arquivo se há um novo arquivo selecionado
            if (this.arquivo) {
                notaFiscal.arquivo = this.arquivo
            }
            this.$emit('salvar', notaFiscal)
        },

        sincronizarValorServico() {
            this.valorServico = this.valorNota
            this.$nextTick(() => {
                this.calcularValoresImpostos()
            })
        },

        fechar() {
            this.$emit('fechar')
        }
    },

    validations: {
        numeroNota: { required },
        dataEmissao: { required },
        mesCompetencia: { required },
        valorNota: { required },
        valorServico: { required },
        prestadorRazaoSocial: { required },
        prestadorOptanteSimples: { required },
        servicoPorSocio: { required },
        descricaoNota: { required }
    }
}
</script>

